import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import React from 'react';
import { useFonts } from 'expo-font';
import { Poppins_600SemiBold, Poppins_500Medium } from '@expo-google-fonts/poppins';
import { useLoginStore } from '../LoginStore';

type Props = {
    onForgotPassword?: () => void
}
export default function RememberAndForgot(props: Props) {

    const isRemembered = useLoginStore(s => s.isRemembered);
    const toggleRemember = useLoginStore(s => s.toggleRemember);

    const [fontsLoaded] = useFonts({
        Poppins_600SemiBold,
        Poppins_500Medium,
    });

    if (!fontsLoaded) return null;

    return (
        <View style={styles.container}>
            <View style={styles.row}>
                <TouchableOpacity
                    style={[styles.checkbox, isRemembered && styles.checked]}
                    onPress={toggleRemember} // ✅ toggle Zustand state
                >
                    {isRemembered && <Text style={styles.checkmark}>✓</Text>}
                </TouchableOpacity>
                <Text style={styles.label}>Remember Me</Text>
            </View>

            <TouchableOpacity onPress={() => props.onForgotPassword?.()}>
                <Text style={styles.forgot}>Forgot Password?</Text>
            </TouchableOpacity>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    checkbox: {
        width: 20,
        height: 20,
        borderWidth: 2,
        borderColor: '#CDD1E0',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
    },
    checked: {
        backgroundColor: '#0E64D2',
    },
    checkmark: {
        color: '#fff',
        fontWeight: 'bold',
    },
    label: {
        marginLeft: 5,
        fontSize: 16,
        color: "#000C14",
        fontFamily: 'Poppins_600SemiBold',
    },
    forgot: {
        fontSize: 16,
        color: "#E86969",
        fontFamily: 'Poppins_500Medium',
    },
});